module.exports = __webpack_public_path__ + "static/img/pickering1.323097d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/pickering1.jpg
// module id = 120
// module chunks = 9